module.exports = __webpack_public_path__ + "img/17.7480b02.png";